import { Typography } from '@atlas-metrics/design-system';
import { useTranslation } from 'next-i18next';
import * as React from 'react';
import { Dispatch, SetStateAction } from 'react';

import { Button } from './ui/buttons';
import IconCircle from './ui/IconCircle';
import Input from './ui/Input';

type PasswordProps = {
  handleSubmit: () => void;
  password: string;
  setPassword: Dispatch<SetStateAction<string>>;
  setIsPasswordIncorrect: Dispatch<SetStateAction<boolean>>;
  isPasswordIncorrect: boolean;
};

export default function Password({
  handleSubmit,
  password,
  setPassword,
  setIsPasswordIncorrect,
  isPasswordIncorrect,
}: PasswordProps) {
  const { t } = useTranslation();

  return (
    <main>
      <section>
        <div className='layout flex min-h-screen flex-col items-center justify-center text-center text-black'>
          <IconCircle
            icon='icon-lock'
            iconClassName='text-ds-purple-600'
            className='bg-ds-purple-50'
          />
          <Typography variant='h4' className='mt-8'>
            {t('welcome')}
          </Typography>
          <Typography variant='body-l' className='mb-16 mt-4 text-ds-grey-700'>
            {t('password.request')}
          </Typography>
          {/* one-off width value until design system is done. */}
          <div className='grid w-[328px] gap-y-10'>
            <Input
              name='password'
              type='password'
              placeholder={t('password.placeholder')}
              onChange={(value) => {
                setPassword(value);
                setIsPasswordIncorrect(false);
              }}
              validationMsg={
                isPasswordIncorrect ? t('password.incorrect') : undefined
              }
              value={password}
              isDisabled={false}
              label={t('password.label')}
            />
            <Button
              size='l'
              text={t('password.access')}
              variant='primary'
              disabled={!password ?? true}
              onClick={handleSubmit}
            />
          </div>
        </div>
      </section>
    </main>
  );
}

export async function getServerSideProps() {
  return {
    props: {
      isServerRendered: true,
    },
  };
}
